/* DJ Motor: skalerer overskrifter ned på mobil, så lange danske ord ikke knækker midt i ordet */
(function () {
  var SELECTOR = 'main h1, main h2, main h3, main .h0, main .h1, main .h2, main .h3';
  var MOBILE_MAX = 749;
  var MIN_SIZE = 16;
  var probe;

  function widestWord(heading, cs) {
    if (!probe) {
      probe = document.createElement('span');
      probe.setAttribute('aria-hidden', 'true');
      probe.style.cssText = 'position:absolute;left:-9999px;top:0;visibility:hidden;white-space:nowrap;';
    }
    ['fontFamily', 'fontWeight', 'fontStyle', 'fontSize', 'letterSpacing', 'textTransform', 'fontStretch'].forEach(function (k) {
      probe.style[k] = cs[k];
    });
    document.body.appendChild(probe);
    var widest = 0;
    (heading.textContent || '').trim().split(/[\s\-‐‑–\/]+/).forEach(function (word) {
      if (!word) return;
      probe.textContent = word;
      widest = Math.max(widest, probe.getBoundingClientRect().width);
    });
    probe.remove();
    return widest;
  }

  function fit() {
    var headings = document.querySelectorAll(SELECTOR);
    headings.forEach(function (h) {
      if (h.hasAttribute('data-dj-fit')) {
        h.style.fontSize = '';
        h.removeAttribute('data-dj-fit');
      }
    });
    if (window.innerWidth > MOBILE_MAX) return;

    headings.forEach(function (h) {
      if (!h.offsetWidth) return;
      var cs = getComputedStyle(h);
      var available = h.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      var widest = widestWord(h, cs);
      if (widest > available) {
        var size = Math.max(MIN_SIZE, Math.floor(parseFloat(cs.fontSize) * (available / widest) * 0.97));
        h.style.fontSize = size + 'px';
        h.setAttribute('data-dj-fit', '');
      }
    });
  }

  var timer;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(fit, 150);
  }

  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  window.addEventListener('load', fit);
  window.addEventListener('resize', schedule);
  document.addEventListener('shopify:section:load', schedule);
})();
